@if (isLoading$ | async) {
  <div class="spinner">
    <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
  </div>
} @else if (step) {
  <section class="step">
    <header class="step-header">
      <div class="step-header-title">
        <span class="step-header-title-text" appLongTextTooltip>
          {{ step.type | stepTypeToLabel | labelsProvider }}
        </span>
        @if (hasRelatedFindings()) {
          <img
            src="assets/images/status-icons/shield-ban.svg"
            alt="Activity was blocked"
            class="blocked-step-icon"
            [matTooltip]="'Activity was blocked'"
            matTooltipPosition="above"
          />
        }
      </div>

      <div class="step-header-secondary-title">
        <div class="step-header-secondary-title-property">
          <img
            *ngIf="getAiServiceIconPath() !== ''"
            [src]="getAiServiceIconPath()"
            [alt]="getAgentHeaderDisplayName() + ' logo'"
            class="ai-service-icon"
          />
          <span>
            {{ getAgentHeaderDisplayName() }}
          </span>
        </div>

        <div class="separator">|</div>
        <div class="step-header-secondary-title">
          {{ step.timestamp | date: 'MMM d, y, HH:mm:ss' }}
        </div>

        <div class="separator">|</div>
        <div class="step-header-secondary-title-property">
          <div>{{ 'aiAgentStepPage.idTitle' | labelsProvider }}</div>
          <app-copy-button
            class="copy-button"
            [value]="step.id"
            [title]="step.id"
            [isSecondaryFontColor]="true"
          ></app-copy-button>
        </div>
      </div>

      <app-sidepanel-tabs
        class="step-header-tabs"
        [tabs]="tabs"
        (tabOnSelection)="activeTabIndex.set($event)"
      ></app-sidepanel-tabs>
    </header>

    <div class="agent-step-actions" *ngIf="activeTabIndex() === 0">
      <mat-progress-spinner
        *ngIf="isActionRunningSpinner"
        class="small-spinner"
        color="primary"
        mode="indeterminate"
        style="left: -20px"
      ></mat-progress-spinner>
      <div class="actions">
        <app-single-page-actions
          class="actions"
          [menuActions]="(menuActions$ | async) || []"
          (actionSelected)="actionSelected($event)"
        ></app-single-page-actions>
      </div>
    </div>
    <div class="step-body">
      <div class="step-body-tab">
        @if (activeTabIndex() === 0 && stepDetailsCardFields.length > 0) {
          <div class="step-body-tab-card step-details-card">
            <div class="step-body-tab-card-title">
              {{ 'aiAgentStepPage.stepDetailsCardTitle' | labelsProvider }}
            </div>
            <app-card-fields [cardFields]="stepDetailsCardFields" />
          </div>
        }

        @if (activeTabIndex() === 0 && a2aCommunicationCardFields.length > 0) {
          <div class="step-body-tab-card step-details-card">
            <div class="step-body-tab-card-title">
              {{ 'aiAgentStepPage.a2aCommunicationCardTitle' | labelsProvider }}
            </div>
            <app-card-fields [cardFields]="a2aCommunicationCardFields" />
          </div>
        }

        @if (citationAndSourceTabs() && (citedSources().length > 0 || sources().length > 0)) {
          <div class="step-body-tab-card step-details-card agent-step__citation-and-sources">
            <div class="step-body-tab-card-title">
              {{ 'aiAgentStepPage.stepSourcesCardTitle' | labelsProvider }}
            </div>

            <app-sidepanel-tabs
              [tabs]="citationAndSourceTabs()"
              (tabOnSelection)="citationAndSourceActiveTab.set($event)"
              class="agent-step__citation-and-source-tabs"
            />

            @if (citedSources().length > 0 && citationAndSourceActiveTab() === 0) {
              @for (source of citedSources(); track source.id) {
                @if ($index < 3 || showMoreCitations()) {
                  <app-ai-agent-citation [citation]="source" />
                }
              }

              @if (citedSources().length > 3) {
                <a (click)="showMoreCitations.set(!showMoreCitations())" class="show-more-link">
                  {{ showMoreCitations() ? 'Show less' : 'Show more' }}
                </a>
              }
            }

            @if (
              sources().length > 0 &&
              ((citedSources().length > 0 && citationAndSourceActiveTab() === 1) ||
                (citedSources().length === 0 && citationAndSourceActiveTab() === 0))
            ) {
              @for (source of sources(); track source.id) {
                @if ($index < 3 || showMoreSources()) {
                  <app-ai-agent-citation [citation]="source" />
                }
              }

              @if (sources().length > 3) {
                <a (click)="showMoreSources.set(!showMoreSources())" class="show-more-link">
                  {{ showMoreSources() ? 'Show less' : 'Show more' }}
                </a>
              }
            }
          </div>
        }
        <div class="step-body-tab-card thread-card" *ngIf="showThreadSection">
          <div class="step-body-tab-card-title">
            {{ 'aiAgentStepPage.threadCardTitle' | labelsProvider }}
          </div>
          <div *ngIf="isThreadIdsLoading$ | async" class="spinner">
            <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
          </div>
          <app-card-fields
            *ngIf="(isThreadIdsLoading$ | async) === false"
            [cardFields]="threadCardFields"
          ></app-card-fields>
          @if ((isThreadIdsLoading$ | async) === false && findingsByThreadId.length > 0) {
            <app-anchor-link navigation="" (clicked)="navigateToThreadFindings()">
              {{ 'aiAgentStepPage.exploreThreadFindingsLinkName' | labelsProvider }}
            </app-anchor-link>
          }
        </div>

        <div class="step-body-tab-card actor-card" *ngIf="actorCardFieldList.length >= 1">
          <app-carousel-card
            *ngIf="actorCardFieldList.length >= 1"
            class="step-body-tab-card-inner"
            [cardFieldsList]="actorCardFieldList"
            titleLabelPath="aiAgentStepPage.actorsCardTitle"
          >
          </app-carousel-card>
        </div>

        <div class="step-body-tab-card client-card">
          <div class="step-body-tab-card-title">
            {{ 'aiAgentStepPage.ClientCardTitle' | labelsProvider }}
          </div>
          <app-card-fields [cardFields]="clientCardFields"></app-card-fields>
        </div>
      </div>
    </div>
  </section>
} @else {
  <div class="no-data-container" *ngIf="showNoData">
    <app-no-data [inDialog]="true"></app-no-data>
  </div>
}

<ng-template #attachmentTemplate>
  <div class="attachments-container">
    @for (document of attachments(); track document.id) {
      <app-badge>
        <img badge-left src="assets/images/common/file.svg" alt="attachment icon" />
        {{ document.displayName }}
        <app-actions-menu-icon
          badge-right
          [actions]="attachmentActions"
          (actionOnClick)="performAttachmentAction($event, document)"
          [smallSize]="true"
          class="attachment-button"
        >
        </app-actions-menu-icon>
      </app-badge>
    }
  </div>
</ng-template>

<ng-template #customAgentTemplate>
  <div class="custom-agent-container">
    @if (shouldShowAgentLink(step.service)) {
      <app-anchor-link navigation="" (clicked)="navigateToAgent()" class="field-link-value">
        <span class="field-link-value__text" appLongTextTooltip>{{ step.botDetails.displayName }}</span>
      </app-anchor-link>
    } @else {
      <span class="agent-name-text" appLongTextTooltip>{{ step.botDetails.displayName }}</span>
    }
    <span class="extension-agent-text"> ({{ 'aiAgentStepPage.m365CopilotExtensionAgent' | labelsProvider }})</span>
    <img
      src="assets/images/common/info.svg"
      alt="Info"
      class="tooltip-icon"
      [matTooltip]="'aiAgentStepPage.m365CopilotExtensionAgentTooltip' | labelsProvider"
      matTooltipPosition="above"
      matTooltipClass="tooltip-container"
    />
  </div>
</ng-template>

<ng-template #findingsTemplate>
  <div class="findings-container" (click)="navigateToThreadFindings(); $event.stopPropagation()">
    <app-severities-cell [severities]="findingsSeverities()" [interactable]="true" />
  </div>
</ng-template>
